type formatLongStrType = (val: string, mid?:string, start?: number, end?:number) => string;
// eslint-disable-next-line import/prefer-default-export
export const formatLongStr: formatLongStrType = (val, mid = '**', start = 4, end = 4) => {
  if (val.length <= start + end) {
    return val;
  }
  return `${val.substr(0, start)}${mid}${val.substr(val.length - end, end)}`;
};

export const formatNumber = (val: number, fixed: number = 4) => Number(val.toFixed(fixed));
